export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          投稿联系
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          欢迎汉化组、原创作者与内容创作者与我们合作
        </p>
        <div className="max-w-xl mx-auto bg-background-50 rounded-xl border border-background-200/70 p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 text-2xl">
            <i className="ri-mail-send-line" />
          </div>
          <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
            期待你的加入
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
            无论你是汉化组、原创漫画作者还是内容创作者，古古漫画网都欢迎你的投稿与合作。
            我们会在 48 小时内回复每一份真诚的来信。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line" />
              商务合作
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-edit-line" />
              漫画投稿
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}